import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Parking } from 'src/features/parkingManagement/types/parking';
import type { ListResponse } from 'src/types';

const RESOURCE = '/parkings/';

type QueryFnType = typeof queryFn;
const queryFn = (): Promise<ListResponse<Parking>> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(),
        ...config,
    });

export { useQueryHook as useGetParkings, RESOURCE as PARKINGS_RESOURCE };
